import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for PlanningBoard
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type PlanningboardParameters = PlanningboardPaywallUpgradeSelectedParameters;
export type PlanningboardEvents = PlanningboardPaywallUpgradeSelectedEvent;

export interface PlanningboardPaywallUpgradeSelectedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
}

export type PlanningboardPaywallUpgradeSelectedParametersSpecific = Omit<
	PlanningboardPaywallUpgradeSelectedParameters,
	'version' | 'companyId' | 'userId'
>;

const planningboardPaywallUpgradeSelectedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class PlanningboardPaywallUpgradeSelectedEventBuilder {
	constructor(private specificParameters: PlanningboardPaywallUpgradeSelectedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<PlanningboardPaywallUpgradeSelectedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			PlanningboardPaywallUpgradeSelectedParametersSpecific,
            PlanningboardPaywallUpgradeSelectedParameters,
			(params: PlanningboardPaywallUpgradeSelectedParameters) => PlanningboardPaywallUpgradeSelectedEvent
		>(this.specificParameters, planningboardPaywallUpgradeSelectedParametersGlobal, globalParams, (params) => new PlanningboardPaywallUpgradeSelectedEvent(params));
	}
}

/**
 * A user clicked on the upgrade button that is shown when trying to plan more than 7 days ahead.
 */
export class PlanningboardPaywallUpgradeSelectedEvent extends CraftnoteEvent<PlanningboardPaywallUpgradeSelectedParameters>{
  constructor(parameters: PlanningboardPaywallUpgradeSelectedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "planningboard_paywall_upgrade_selected"
		},
	]);
  }
}
